
import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";
import { PnlComponent } from "./pnl.component";

export class HistoricalChartButtonComponent implements IComponent {
    public id = StringHelpers.newGuid();;

    private element: HTMLElement;
    private base: IChartContainer;

    constructor(el: HTMLElement, base: IChartContainer) {
        this.element = el;
        this.base = base;
        this.base.tiChartSeries?.subscribeExtremeChange(this.id, () => {
            this.setPosition();
            this.toggleButton()
        });
        this.base.tiChartSeries?.subscribeRedrawChange(this.id, () => {
            this.setPosition();
            this.toggleButton()
        });

        this.onClick();
        this.onResize();
    }

    public setPosition() {
        if (!this.base.tiChartSeries) {
            return;
        }

        const xAxis: any = this.base.tiChartSeries.highStockChart?.xAxis[0];
        if (!xAxis) {
            return;
        }

        let extraTop = 10 + (this.base.tiChartSeries.hasAnyComparisonSymbols() ? 20 : 0);

        if (this.base.pnpMode) {
            if (this.base.marketingWebChartMode) {
                extraTop -= 10;
            } else {
                if (this.base.tiChartSeries.chartStyleSettings?.pnpChangePercentEnabled) {
                    extraTop -= 15;
                } else {
                    extraTop -= 40;
                }
            }
        }

        let left = xAxis.width - 20;

        if (this.base.isExtraSmall()) {
            extraTop = -10;
            left -= 50;
        }

        const top = xAxis.height + extraTop;

        this.element.style.top = top + 'px';

        if (this.base.marketingWebChartMode) {
            // left = xAxis.width - 80;
            this.element.style.left = 'unset';
            this.element.style.right = '110px';

            if (this.base.pnpMode) {
                this.element.style.right = '50px';
            }
        } else if (!this.base.marketingWebChartMode && this.base.pnpMode) {
            this.element.style.left = 'unset';
            this.element.style.right = '80px';
        } else {
            this.element.style.left = left + 'px';
        }
    }

    private onClick() {
        this.element.addEventListener('click', () => {
            if (!this.base.tiChartSeries) {
                return;
            }

            this.base.tiChartSeries.highChartAxisBuilder.redrawYAxis = true;
            this.base.tiChartSeries.highChartAxisBuilder.manualMoveYAxisScale = false;
            this.base.tiChartSeries.highChartAxisBuilder.manualExpandYAxisScale = false;
            this.base.tiChartSeries?.highStockChart?.yAxis?.[0].setExtremes(null, null)

            this.base.tiChartSeries.yAxisMoved = false;
            this.base.tiChartSeries.extreamMin = this.base.tiChartSeries.originalMinimumXValueWithZoom;
            this.base.tiChartSeries.extreamMax = this.base.tiChartSeries.originalMaximumXValue;
            this.base.tiChartSeries?.setExtremes(this.base.tiChartSeries.extreamMin, this.base.tiChartSeries.extreamMax);
            setTimeout(() => {
                this.base.tiChartSeries?.highChartAxisBuilder.buildAxisComponents();

                setTimeout(() => {
                    const pnl = this.base.getComponentsByType(PnlComponent)?.[0] as PnlComponent;
                    if (pnl && !!pnl.selectedAccount && !this.base.isTouchDevice) {
                        this.base?.tiChartSeries?.setExtreamToExitOrderIfExist();
                    }
                }, 25);
            }, 50);
        });
    }

    private toggleButton() {
        setTimeout(() => {
            if (!this.base.tiChartSeries) {
                return;
            }

            let shouldDisplayButton = !this.base.tiChartSeries.shouldHideHistoryModeButton()
                || this.base.tiChartSeries.highChartAxisBuilder.manualMoveYAxisScale
                // || this.base.tiChartSeries.highChartAxisBuilder.manualExpandYAxisScale
            if (shouldDisplayButton) {
                this.element.classList.remove('hidden');
            } else {
                this.element.classList.add('hidden');
            }
        }, 150);
    }

    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            this.setPosition();
        });
    }
}